export default "__VITE_ASSET__CBJC8jp3__"